<template>
    <div id="app" :class="['page-' + $router.currentRoute.name.toLowerCase(), $router.currentRoute.meta.topClass ? 'top-' + $router.currentRoute.meta.topClass : '']">
        <div id="wrapper" class="">
            <router-view :key="$route.fullPath"/>
        </div>

        <div id="modal-agendar" class="modal">
            <div class="row agendar">
                <div class="col-lg-12" v-if="$root.modalAgendarData">
                    <div class="row">
                        <div class="col-xl-6 col-xs-12 col-md-12 col-lg-6">                                          
                            <div class="header-image" :style="{'background-image': 'url(' + $root.modalAgendarData.detalhes.imagem + ')'}"></div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-xs-12 col-md-12">                                          
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hidden-lg hidden-xl margin-top-20"></div>
                                    <h3 class="margin-bottom-0">{{$root.modalAgendarData.detalhes.nome}}</h3>
                                    <p class="margin-top-0 margin-bottom-5">
                                        {{$root.modalAgendarData.detalhes.descricao}}
                                    </p>                      
                                    <span class="dashboard-status-button gray">
                                        {{$root.modalAgendarData.detalhes.categorias}}
                                    </span>
                                </div>

                                <div class="col-xl-12">
                                    <p class="page-text margin-bottom-10 margin-top-20">
                                        Você tem certeza que deseja agendar a consulta de <b>{{$root.modalAgendarData.agendamento.DS_COMPLEMENTO}}</b> para <b>{{$root.modalAgendarData.agendamento.DT_AGENDA_EXT}}</b>?
                                    </p>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                <!-- <div class="col-xl-6 col-lg-6 col-xs-12 col-md-12"> -->
                                    <button type="button" class="button green block-mobile margin-bottom-10" onclick="window.__app.modalAgendarSubmit()">
                                        <i class="material-icons">check_circle</i>
                                        Enviar agendamento
                                    </button>
                                    <button type="button" class="button red block-mobile" style="" onclick="window.__app.back()">
                                        <i class="material-icons">close</i>
                                        Cancelar
                                    </button>                            
                                </div>                        
                            </div>                        
                        </div>                        
                    </div>
                </div>
            </div>
        </div> 

        <div id="modal-termos-de-uso" class="modal">
            <div class="row" v-if="$root.config['termos-de-uso']">
                <div class="col-lg-12 margin-bottom-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12">                                          
                            <h3>Termos de uso</h3>
                        </div>

                        <div class="col-lg-12 col-xs-12 col-xl-12 v-html" v-html="$root.config['termos-de-uso'].conteudo">
                        </div>                     
                    </div>
                </div>
            </div>
        </div>
   

        <div id="modal-politicas-de-privacidade" class="modal">
            <div class="row" v-if="$root.config['politicas-de-privacidade']">
                <div class="col-lg-12 margin-bottom-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12">                                          
                            <h3 class="">Políticas de privacidade</h3>
                        </div>

                        <div class="col-lg-12 col-xs-12 col-xl-12 v-html" v-html="$root.config['politicas-de-privacidade'].conteudo">
                        </div>                                  
                    </div>
                </div>
            </div>
        </div>     

        <div id="modal-sintomas" class="modal modal-center">
            <div class="row xs-center center center-xs">
                <div class="col-lg-12">
                    <div class="row" v-for="(item, index) in $root.config.sintomas.itens" :key="item.cod" v-show="$root.sintomas.etapa == index">

                        <div class="col-xl-12">                                          
                            <h3 class="">{{item.texto}}</h3>
                        </div>

                        <div class="col-xl-12" v-for="(item2, index2) in item.itens" :key="item2.cod">
                            <button type="button" class="button transparent margin-bottom-5 color-secondary" onclick="window.__app.enviarSintomas(this)" :data-index="index" :data-index2="index2">
                                {{item2.texto}}
                            </button>                        
                        </div>

                    </div>
                </div>
            </div>
        </div>                         


    </div>
</template>

<script>
import Top from './components/Top'

export default {
    name: 'App',
    components: {
        'Top': Top,
    },
    methods: {        
        data () {
            var self                    = this;
            return {        
                "modalAgendarData":     null,
            }
        },        
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "multiplo":     true,
                        "nome":         "termos-de-uso,politicas-de-privacidade,menu"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getConfig() response", response);
                    response.data.result.itens.forEach(function(item) {
                        self.$root.config[item.nome] = item.objeto; 
                    });
                    setTimeout(function() {
                        self.$forceUpdate();
                        self.$root.$forceUpdate();
                    }, 100);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);
                    
                });   
            });   
        },             
    },
    mounted: function() {
        console.log("app mounted >");
        var self = this;
        setTimeout(function() {
            // self.getConfig();
        }, 200)
    }
}
</script>

<style>


#app {


}
</style>



// WEBPACK FOOTER //
// src/App.vue